import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon";

const AccountSecondaryContents = ({ active }) => {
  const { calculator } = useStaticQuery(graphql`
    query AccountSecondaryContents {
      calculator: mysqlBlog(mysqlId: {eq: 982}) {
        terms_path
        term_normalized
        url
      }
    }
  `);

  if (!calculator) {
    return null;
  }

  return (<>
    <strong>Kalkulatory</strong>

    <Link
      to={resolveUrl(calculator.terms_path, calculator.term_normalized, calculator.url)} 
      className={["top-navigation-link", b.mt2, b.mb4].join(' ')}
    >
      {active && <span className="top-navigation-link-icon">
        <Icon icon="Piggy-bank" size={34} />
      </span>}

      Kalkulator sesji Elixir
    </Link>
  </>);
};

export default AccountSecondaryContents;
